'use client';

import { useEffect } from 'react';
import type { ScratchGameApi } from '@/api/cms';
import { useTimeoutRegistrationModal } from '@/hooks/timeoutRegistrationModal';
import { ReceiveBonusesNotice } from '@/modules/common';
import { FAQByGroup } from '@/modules/restrictions/components/FAQByGroup';
import { useScratchGameLootbox } from '../../hooks';
import { BottomSection } from './components/BottomSection';
import { HowToParticipateSection } from './components/CmsHowToParticipate';
import { ScratchActionButton } from './components/ScratchActionButton';
import { ScratchTicketSection } from './components/ScratchTicketSection';
import { TopSection } from './components/TopSection';

import {
  ScContainerMain,
  ScScratchGamePage,
  ScScratchGamePageTitle,
} from './styled';

interface ScratchGamePageProps {
  data: ScratchGameApi;
}

const ScratchGamePage: React.FC<ScratchGamePageProps> = ({ data }) => {
  useTimeoutRegistrationModal();

  const { ticketTheme, bonus, setBonus, setIsFinished, isAuthenticated } =
    useScratchGameLootbox();

  const {
    topBg,
    leftImg,
    leftDecorImg,
    rightImg,
    rightDecorImg,
    mobImg,
    pageTitle,
    howToParticipate,
    faq,
  } = data;

  useEffect(() => {
    if (!isAuthenticated) {
      setIsFinished(ticketTheme, false);
      setBonus(ticketTheme, null);
    }

    return () => {
      setIsFinished(ticketTheme, false);
      setBonus(ticketTheme, null);
    };
  }, [isAuthenticated]);

  return (
    <ScScratchGamePage>
      <TopSection
        bg={topBg?.url || ''}
        leftDecorImg={leftDecorImg?.url || ''}
        leftImg={leftImg?.url || ''}
        mobImg={mobImg?.url || ''}
        rightDecorImg={rightDecorImg?.url || ''}
        rightImg={rightImg?.url || ''}
      >
        <div className="bonuses-notice-box">
          <ReceiveBonusesNotice
            successMessage="canIssueBonuses.success"
            translation="promotions"
            warningMessage="canIssueBonuses.warning"
          />
        </div>

        <ScContainerMain>
          <ScScratchGamePageTitle>{pageTitle}</ScScratchGamePageTitle>
          <ScratchTicketSection />
        </ScContainerMain>
      </TopSection>

      <BottomSection>
        <div className="content">
          <HowToParticipateSection sections={howToParticipate} />
          <FAQByGroup sections={faq} withTitle />
        </div>

        <ScratchActionButton bonus={bonus[ticketTheme]} />
      </BottomSection>
    </ScScratchGamePage>
  );
};

export default ScratchGamePage;
